import { IRewardItem } from '../../../../State/reducers/score';
import { createOutlineText, scaleToFit } from '../../../../Utils/Utils';
import { DynamicList } from '../../../Shared/Layout/DynamicList';

export class ItemsList extends PIXI.Container {
    constructor(items: IRewardItem[], height: number, itemWidth: number, itemHeight: number) {
        super();

        const itemList = new DynamicList(height);
        const listItems = [];
        for (const item of items) {
            const icon = new PIXI.Sprite(
                PIXI.utils.TextureCache[`commonui/shop_icon_booster_${item.id.toLowerCase()}`]
            );
            icon.anchor.set(0.5);
            const text = createOutlineText(
                `x${item.val}`,
                new PIXI.Rectangle(0, 0, itemWidth, itemHeight),
                'Baloo'
            );
            text.scale.set(scaleToFit(text.width, text.height, itemWidth, itemHeight));
            icon.scale.set(scaleToFit(icon.width, icon.height, text.width, text.height));
            const container = new PIXI.Container();
            text.x = icon.width * 0.4 + text.width / 2;
            container.addChild(icon, text);
            listItems.push(container);
        }
        itemList.addItem(...listItems);
        this.addChild(itemList);
    }
}
